export default [

    {
        path: '',
        name: 'dashboard',
        component: () => import('@/aplicacao/modulos/dashboard/Dashboard'),
        meta: { autenticacao: true },
    },

]
